import React, { useState } from "react";
import { Typography } from "antd";
import { PhoneOutlined } from "@ant-design/icons";
import { ModalItem, InputItem, ButtonItem } from "../../../../Components/Items";
import SelectorPlantillas from "./Selectores/SelectorPlantillas";
import SelectorContactoItem from "./Selectores/SelectorContactoItem";
import ModalContacto from "../../CRM/Components/ModalContacto";
import { WA } from "../theme";

const { Text } = Typography;

const ModalNuevaConversacion = ({
  visible,
  headersToken,
  empresaId,
  onIniciarYEnviar,
  onCancel,
}) => {
  const [fase, setFase] = useState("telefono");
  const [telefono, setTelefono] = useState("");
  const [contacto, setContacto] = useState(null);
  const [modalContacto, setModalContacto] = useState(false);
  const [error, setError] = useState("");

  const handleContinuar = () => {
    const digitos = telefono.replace(/\D/g, "");
    if (digitos.length < 10) {
      setError("Ingresa un número válido de al menos 10 dígitos.");
      return;
    }
    setError("");
    setFase("plantilla");
  };

  const handleEnviar = (fd) => {
    onIniciarYEnviar(
      telefono,
      fd,
      () => {
        setFase("telefono");
        setTelefono("");
        setContacto(null);
        onCancel();
      },
      contacto?._id,
    );
  };

  const handleCancel = () => {
    if (fase === "plantilla") {
      setFase("telefono");
      return;
    }
    setTelefono("");
    setContacto(null);
    setError("");
    onCancel();
  };

  if (!visible) return null;

  return (
    <>
      <ModalItem
        title="Nueva conversación"
        visible={fase === "telefono"}
        onCancel={handleCancel}
        footer={null}
        spinning={false}
      >
        <div style={{ marginBottom: 16 }}>
          <Text style={{ color: WA.textSecondary, fontSize: 13 }}>
            Ingresa el número de WhatsApp del contacto. Deberás enviar una
            plantilla aprobada para iniciar la conversación.
          </Text>
        </div>
        <div style={{ marginBottom: 12 }}>
          <Text style={{ fontSize: 12, color: WA.textSecondary, display: "block", marginBottom: 4 }}>
            Contacto del CRM (opcional)
          </Text>
          <SelectorContactoItem
            headersToken={headersToken}
            empresaId={empresaId}
            value={contacto}
            onChange={(c) => {
              setContacto(c);
              if (c?.numero) setTelefono(c.numero);
              setError("");
            }}
          />
          <ButtonItem
            turquesa
            lessTime
            style={{ marginTop: 4 }}
            onClick={() => setModalContacto(true)}
          >
            + Crear contacto nuevo
          </ButtonItem>
        </div>
        <InputItem
          label="Número de teléfono"
          placeholder="Ej. 5512345678 o +525512345678"
          value={telefono}
          onChange={(e) => {
            setTelefono(e.target.value);
            setError("");
          }}
          onPressEnter={handleContinuar}
          prefix={<PhoneOutlined style={{ color: WA.textSecondary }} />}
        />
        {error && (
          <Text style={{ color: "#ff4d4f", fontSize: 12 }}>{error}</Text>
        )}
        {contacto && (
          <Text style={{ fontSize: 12, color: WA.textSecondary, display: "block", marginTop: 6 }}>
            Se vinculará a {contacto.stringBuscar || contacto.nombre}
          </Text>
        )}
        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 16, gap: 8 }}>
          <ButtonItem onClick={handleCancel}>Cancelar</ButtonItem>
          <ButtonItem
            type="primary"
            lima
            onClick={handleContinuar}
            disabled={!telefono.trim()}
          >
            Continuar → elegir plantilla
          </ButtonItem>
        </div>
      </ModalItem>

      <ModalContacto
        visible={modalContacto}
        idContacto={null}
        datosIniciales={{
          numero: telefono.replace(/\D/g, "") || undefined,
          origen: "WhatsApp",
        }}
        onCancel={() => setModalContacto(false)}
        onSuccess={(id, c) => {
          if (c) {
            setContacto(c);
            if (c.numero) setTelefono(c.numero);
          }
          setModalContacto(false);
        }}
      />

      <SelectorPlantillas
        visible={fase === "plantilla"}
        headersToken={headersToken}
        empresaId={empresaId}
        onCancel={() => setFase("telefono")}
        onEnviar={handleEnviar}
      />
    </>
  );
};

export default ModalNuevaConversacion;
